import React, { useState } from 'react';

import { ReactComponent as ProductSVG } from '../images/product.svg';
import styles from './ProductImage.module.css';

const ProductImage = ({ src, alt }) => {
  const [error, setError] = useState(false);
  const handleError = () => setError(true);

  // show placeholder if image is missing/broken
  if (!src || error) {
    return (
      <div className={styles.container}>
        <ProductSVG />
      </div>
    );
  }

  return <img src={src} alt={alt} onError={handleError} />;
};

export default ProductImage;
